import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/inventoryIssueStatusReport'
import Component from 'components/Reports/InventoryIssueStatusReport'

export default createListViewContainer({ actions, selectors: selectors.inventoryIssueStatusReport })(Component)
